import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section, Reveal, SectionTitle } from './Section';
const faqs = [{
  q: '¿Cómo recibiré el material?',
  a: 'Una vez confirmado tu pago recibirás acceso inmediato para descargar todos los archivos.'
}, {
  q: '¿Los archivos son PDF?',
  a: 'Sí. Todo el contenido se entrega en formato PDF de alta calidad.'
}, {
  q: '¿Es un pago único?',
  a: 'Sí. No existen mensualidades ni suscripciones.'
}, {
  q: '¿Funciona en cualquier país?',
  a: 'Sí. El sistema puede adaptarse fácilmente a cualquier contexto educativo. Además, el cambio de moneda es automático.'
}, {
  q: '¿Tendré acceso para siempre?',
  a: 'Sí. La compra incluye acceso de por vida.'
}];
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-white" data-id="element-76">
      <Reveal className="text-center" data-id="element-77">
        <SectionTitle data-id="element-78">Preguntas Frecuentes</SectionTitle>
      </Reveal>

      <div className="mx-auto mt-8 max-w-2xl space-y-3" data-id="element-79">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <Reveal key={f.q} delay={i * 0.04} data-id="element-80">
              <div className="overflow-hidden rounded-2xl border border-brand-purple/10 bg-brand-cream" data-id="element-81">
                <button onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left" data-id="element-82">
                  <span className="font-display text-base font-extrabold text-brand-purpleDark" data-id="element-83">
                    {f.q}
                  </span>
                  <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-purple transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-84" />
                </button>
                <AnimatePresence initial={false} data-id="element-85">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25,
                ease: 'easeInOut'
              }} data-id="element-86">
                      <p className="px-5 pb-4 text-sm font-semibold text-brand-purpleDark/75" data-id="element-87">
                        {f.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </Reveal>;
      })}
      </div>
    </Section>;
}